import React, { useState, useEffect } from 'react';

// react-bootstrap components
import {
    Badge,
    Button,
    Card,
    Form,
    InputGroup,
    Navbar,
    Nav,
    Table,
    Container,
    Row,
    Col,
    OverlayTrigger,
    Tooltip,
    ListGroup
} from "react-bootstrap";


const FeatureFlagList = (props) => {

    let featureFlagItems;

    if (props.featureFlags) {
        featureFlagItems = props.featureFlags.map((flag, index) => {
            let id = `${flag.id}`;
            return (
                <tr key={index}>
                    <td>{flag.name}</td>
                    <td>{flag.description}</td>
                    <td>{flag.startDate}</td>
                    <td>{flag.endDate}</td>
                    <td>
                        <Form.Check
                            type="switch"
                            id={id}
                            className="mb-1"
                            checked={flag.enabled}
                            onChange={props.onFlagToggleChange}
                        />
                    </td>
                </tr>
            )
        })
    }

    return (
        <Table className="table-striped">
            <thead>
                <tr className="bg-white z-1000">
                    <th className="col-1 text-16">Name</th>
                    <th className="text-16">Description</th>
                    <th className="text-16">Start Date</th>
                    <th className="text-16">End Date</th>
                    <th className="text-16">Enabled</th>
                </tr>
            </thead>
            <tbody>
                {featureFlagItems}
            </tbody>
        </Table>
    )
}

export default FeatureFlagList;